import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-needs-principal-attestation-dialog',
    templateUrl: './needs-principal-attestation-dialog.component.html',
    styleUrls: ['./needs-principal-attestation-dialog.component.scss'],
    standalone: false
})
export class NeedsPrincipalAttestationDialogComponent {
  isChanged: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private dialogRef: MatDialogRef<NeedsPrincipalAttestationDialogComponent>) {
  }

  onCheckboxChanged(): void {
    this.isChanged = !this.isChanged; // Toggle the isChanged state
  }

  onCancelClicked(): void {
    // Close the dialog without making any changes
    this.dialogRef.close();
  }
}
